import { axiosIntance } from "./config";

export const getAllLead = async () => {
  const response = await axiosIntance.get("/leads");
  return response.data;
};

export const getLeads = async () => {
  const response = await axiosIntance.get("/leads");
  return response.data;
};

export const createLead = async (data) => {
  const response = await axiosIntance.post("/leads", data);
  return response.data;
};

export const updateLead = async (id, payload) => {
  const response = await axiosIntance.put(`/leads/${id}/status`, payload);
  return response.data;
};

export const deleteLead = async (id) => {
  const response = await axiosIntance.delete(`/leads/${id}`);
  return response.data;
};

export const getFrachisesLead = async () => {
  const response = await axiosIntance.get("/franchises");
  return response.data;
};
